



























































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Analysehandlewarning from "./analyse-handlewarning.vue";
import EdithandleContent from "../handlewarning/edit-handleContent.vue";
import SeethhandleContent from "../handlewarning/see-handleContent.vue";
class PageThRealTimeDataRequest extends PageRequest {
  FilterText: string;
  cId:Number;
  AddTime:Date=new Date();
}
class PageCompanyRequest{
  cId:Number;
}
@Component({
  components: { EdithandleContent,SeethhandleContent,Analysehandlewarning },
})
export default class Floors extends AbpBase {
  pagerequest: PageThRealTimeDataRequest = new PageThRealTimeDataRequest();
  pagecompanyrequest: PageCompanyRequest = new PageCompanyRequest();
  seeModalShow: boolean = false;
  editModalShow: boolean = false;
  userName: string;
  cId:Number;
  mac:string='';
  locationName:string='';
  minTemp:number;
  maxTemp:number;
  minHumi:number;
  maxHumi:number;
  analyseModalShow: boolean = false;
  selDateTime:Date=new Date();
  searchInt:number = 0;

  get list() {
    return this.$store.state.thhandlewarning.list;
  }
  get loading() {
    return this.$store.state.thhandlewarning.loading;
  }
  selCompany(value:Number){
    this.pagecompanyrequest.cId = value;
    this.getwarehouse();
      this.getfloor();
       this.getpage();
  }
  pageChange(page: number) {
    this.$store.commit("thhandlewarning/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("thhandlewarning/setPageSize", pagesize);
    this.getpage();
  }
  getsearch(){
    this.searchInt = 1;
    this.getpage();
  }
  async getpage() {
    if(this.searchInt == 1){
      this.$store.state.thequipment.currentPage=1;
      this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = 0;
      this.searchInt = 0;
    }
    else
    {
      this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    }
    if(this.pagerequest.AddTime.toString() == ""){
      this.pagerequest.AddTime = new Date();
    }
    //filters
    await this.$store.dispatch({
      type: "thhandlewarning/getPage",
      data: this.pagerequest,
    });
  }

  edit() {
    this.editModalShow = true;
  }
  see() {
    this.seeModalShow = true;
  }
  get pageSize() {
    return this.$store.state.thhandlewarning.pageSize;
  }
  get totalCount() {
    return this.$store.state.thhandlewarning.totalCount;
  }
  get currentPage() {
    return this.$store.state.thhandlewarning.currentPage;
  }
  getuserName() {
    this.userName = this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
    return this.userName;
  }
  get company() {
    return this.$store.state.company.list;
  }
  companylist() {
    return this.$store.state.company.list;
  }
  get warehouse() {
    return this.$store.state.warehouse.list;
  }
  get floor() {
    return this.$store.state.floor.list;
  }
  warehouselist() {
    return this.$store.state.warehouse.list;
  }
  floorlist() {
    return this.$store.state.floor.list;
  }
  get factory() {
    return this.$store.state.factory.list;
  }
  factorylist(){
    return this.$store.state.factory.list;
  }
  get smokecrib() {
    return this.$store.state.smokecrib.list;
  }
  smokecriblist(){
    return this.$store.state.smokecrib.list;
  }
  //  analyse() {
  //   this.selDateTime=this.pagerequest.AddTime;
  //   this.analyseModalShow = true;
  // }
 setmac(val){
    this.mac=val;
  }
  setNames(paramftid,paramwid,paramfid,paramlocation){
    let ftid = paramftid;
    let wid = paramwid;
    let fid = paramfid;
    let ftlist = this.factorylist(); 
    for (let entry of ftlist) {
      if(ftid==entry.id){
        ftid=entry.fName;
        break;
      }
    }
    let wlist = this.warehouselist(); 
    for(let entry of wlist) {
      if(wid==entry.id){
        wid=entry.wName;
        break;
      }
    }
    let flist = this.floorlist();
    for(let entry of flist){
      if(fid == entry.id){
        fid = entry.fName;
        break;
      }
    }
    this.locationName =ftid + wid + fid + paramlocation;
    if(ftid == 0){
      this.locationName =wid + fid + paramlocation;
    }

  }
  columns = [
    {
      title: "所属公司",
      key: "cId",
      render: (h, params) => {
        let cId = params.row.cId;
        let clist = this.companylist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if (cId == entry.id) {
            cId = entry.cName;
            break;
          }
        }
        if (cId == 0) {
          cId = "";
        }
        return h("span", cId);
      },
    },
    {
      title: "库区",
      key: "ftId",
      render: (h, params) => {
        let Id = params.row.ftId;
        let flist = this.factorylist(); 
        for (let entry of flist) {
          if(Id==entry.id){
            Id=entry.fName;
            break;
          }
        }
        return h("span", Id);
      },
    }, 
     {
      title: "库房",
      key: "wId",
       render: (h, params) => {
        let wId = params.row.wId;
        let clist = this.warehouselist();
        //console.log(clist); 
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(wId==entry.id){
            wId=entry.wName;
            break;
          }
        }
        return h("span", wId);
      },
    },
    {
      title: "楼层",
      key: "fId",
      render: (h, params) => {
        let fId = params.row.fId;
        let clist = this.floorlist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(fId==entry.id){
            fId=entry.fName;
            break;
          }
        }
        return h("span", fId);
      },
    },
    {
      title: "SN号",
      key: "mac",
    },
     {
      title: "烟叶",
      key: "scId",
      render: (h, params) => {
        let scId = params.row.scId;
        let clist = this.smokecriblist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(scId==entry.id){
            scId=entry.title;
            break;
          }
        }
        return h("span", scId);
      },
    },
    {
      title: "位置",
      key: "locationName",
    },
    {
      title: "温度",
      key: "temp1",
      width:150,
      render:(h,params) =>{
        let temp1color = 'black';
        let temp2color = 'black';
        let temp3color = 'black';
        if(params.row.temp1 > params.row.maxtemp || params.row.temp1 < params.row.mintemp){
          temp1color = 'red';
        }
        if(params.row.temp2 > params.row.maxtemp || params.row.temp2 < params.row.mintemp){
          temp2color = 'red';
        }
        if(params.row.temp3 > params.row.maxtemp || params.row.temp3 < params.row.mintemp){
          temp3color = 'red';
        }
        return h("span",[
          h("p",{style:'color:' + temp1color},'一号针：' + params.row.temp1 + '℃'),
          h("p",{style:'color:' + temp2color},'二号针：' + params.row.temp2 + '℃'),
          h("p",{style:'color:' + temp3color},'三号针：' + params.row.temp3 + '℃')
        ]);

      }
    },
    {
      title: "湿度",
      key: "humi1",
      width:150,
      render:(h,params) =>{
        let humi1color = 'black';
        let humi2color = 'black';
        let humi3color = 'black';
        if(params.row.humi1 > params.row.maxhumi || params.row.humi1 < params.row.minhumi){
          humi1color = 'red';
        }
        if(params.row.humi2 > params.row.maxhumi || params.row.humi2 < params.row.minhumi){
          humi2color = 'red';
        }
        if(params.row.humi3 > params.row.maxhumi || params.row.humi3 < params.row.minhumi){
          humi3color = 'red';
        }
        return h("span",[
          h("p",{style:'color:' + humi1color},'一号针：' + params.row.humi1 + '%'),
          h("p",{style:'color:' + humi2color},'二号针：' + params.row.humi2 + '%'),
          h("p",{style:'color:' + humi3color},'三号针：' + params.row.humi3 + '%')
        ]);

      }
    },
    {
      title: "更新时间",
      key: "addTime",
      render: (h, params) => {
        let addTime ='';
        
        addTime=this.GetDay(params.row.addTime)+' '+this.GetMinutes(params.row.addTime);
        return h("span", addTime);
      },
    },
    {
      title:"是否处理",
      key:"htype",
      width:100,
      render:(h,params) =>{
        let htype = params.row.htype;
        let returns = "待处理";
        if(htype ==1){
          returns = "已处理";
        }
        return h("span",returns);
      }
    },
    {
      title:"处理人",
      key:"handlerOne",
    },
    {
      title: "处理时间",
      key: "hTime",
      render: (h, params) => {
        let hTime ='';
        
        hTime=this.GetDay(params.row.hTime)+' '+this.GetMinutes(params.row.hTime);
        return h("span", hTime);
      },
    },
    {
      title:"处理内容",
      key:"hContent",
    },
    {
      title: "操作",
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        if(params.row.htype == 0){
          return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  //console.log(params.row)
                  if(params.row.handlerOne == ''){
                    params.row.handlerOne =this.$store.state.session.user? this.$store.state.session.user.name: "";
                  }
                  this.$store.commit("thhandlewarning/edit", params.row);
                  this.edit();
                },
              },
            },
            "预警处理"
          ),
          // h(
          //   "Button",
          //   {
          //     props: {
          //       type: "primary",
          //       size: "small",
          //     },
          //     style: {
          //       marginRight: "5px",
          //     },
          //     on: {
          //       click: () => {
          //         this.setmac(params.row.mac);
          //        this.setNames(params.row.ftId,params.row.wId,params.row.fId,params.row.locationName);
          //         this.$store.commit("thhandlewarning/analyse", params.row);
          //          //console.log(this.mac+'aaa');
          //         this.analyse();
          //       },
          //     },
          //   },
          //   "数据分析"
          // ),
         
        ]);
        }
        else{
          return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  //console.log(params.row)
                  if(params.row.handlerOne == ''){
                    params.row.handlerOne =this.$store.state.session.user? this.$store.state.session.user.name: "";
                  }
                  params.row.hTime = this.GetDay(params.row.hTime)+' '+this.GetMinutes(params.row.hTime);
                  this.$store.commit("thhandlewarning/see", params.row);
                  this.see();
                },
              },
            },
            "查看"
          ),
          // h(
          //   "Button",
          //   {
          //     props: {
          //       type: "primary",
          //       size: "small",
          //     },
          //     style: {
          //       marginRight: "5px",
          //     },
          //     on: {
          //       click: () => {
          //         this.setmac(params.row.mac);
          //        this.setNames(params.row.ftId,params.row.wId,params.row.fId,params.row.locationName);
          //         this.$store.commit("thhandlewarning/analyse", params.row);
          //          //console.log(this.mac+'aaa');
          //         this.analyse();
          //       },
          //     },
          //   },
          //   "数据分析"
          // ),
         
        ]);
        }
        
      },
    },
  ];
  async getcompany() {
    //filters
    await this.$store.dispatch({
      type: "company/getAll"
    });
   
  }
  async getwarehouse() {
    //库房
    //filters
    await this.$store.dispatch({
      type: "warehouse/getAll",
      data: this.pagecompanyrequest,
    });
  }
  async getfloor() {
    //楼层
    //filters
    await this.$store.dispatch({
      type: "floor/getAll",
      data: this.pagecompanyrequest,
    });
  }
  async getfactory(){
      //库区
    //filters
    await this.$store.dispatch({
      type: "factory/getPaged",
      data: this.pagecompanyrequest,
    });
  }
  async getsmokecrib() {
    //烟叶
    //filters
    await this.$store.dispatch({
      type: "smokecrib/getAll",
       data: this.pagecompanyrequest,
    });
  }
  GetDay(time) {
    let date = new Date(time);
    let Str = date.getFullYear() + "-" + (date.getMonth()+1) + "-" + date.getDate();
    return Str;
  }

  GetMinutes(time) {
    let date = new Date(time);
    let Str = this.GetBqMinutes(date.getHours()) + ":" + this.GetBqMinutes(date.getMinutes());
    return Str;
  }
GetBqMinutes(str){
    if(str.toString().length==1){
      return '0'+str;
    }
    return str;
  }
  created() {
    //console.log(111);
    this.getuserName();
    if (this.userName !== "admin") {
      this.getwarehouse();
      this.getfloor();
      this.getfactory();
      this.getsmokecrib();
      
      //不符合权限的，你就没有操作这个列名！！！
      this.columns = this.columns.filter((col) => col.title !== "所属公司");
    } else {
      this.getcompany();
    }

    this.getpage();
  }
}
